import React, { SVGAttributes } from 'react';

export const DposLoyaltyDefault = (props: SVGAttributes<unknown>): JSX.Element => (
  <svg width='56' height='56' viewBox='0 0 56 56' fill='none' {...props}>
    <rect width='56' height='56' fill='white' />
    <path d='M49.5353 13.4142L48.8282 16.9497L45.9998 14.1213L49.5353 13.4142Z' fill='white' />
    <path d='M49.5353 13.4142L48.8282 16.9497L45.9998 14.1213L49.5353 13.4142Z' fill='currentColor' fillOpacity='0.5' />
    <path d='M6.09068 16.2545L7.41677 19.0708L4.00103 18.5618L6.09068 16.2545Z' fill='white' />
    <path d='M6.09068 16.2545L7.41677 19.0708L4.00103 18.5618L6.09068 16.2545Z' fill='currentColor' fillOpacity='0.5' />
    <path d='M30.0908 50.5374L28.5707 53.254L26.9985 50.1791L30.0908 50.5374Z' fill='white' />
    <path d='M30.0908 50.5374L28.5707 53.254L26.9985 50.1791L30.0908 50.5374Z' fill='currentColor' fillOpacity='0.5' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8.38638 43.8508C8.94044 43.4389 9.05573 42.6559 8.64389 42.1018C8.23205 41.5478 7.44904 41.4325 6.89498 41.8443L6.00014 40.6405C7.21906 39.7344 8.94169 39.9881 9.84774 41.207C10.7538 42.4259 10.5001 44.1486 9.28122 45.0546L8.38638 43.8508Z'
      fill='white'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8.38638 43.8508C8.94044 43.4389 9.05573 42.6559 8.64389 42.1018C8.23205 41.5478 7.44904 41.4325 6.89498 41.8443L6.00014 40.6405C7.21906 39.7344 8.94169 39.9881 9.84774 41.207C10.7538 42.4259 10.5001 44.1486 9.28122 45.0546L8.38638 43.8508Z'
      fill='currentColor'
      fillOpacity='0.5'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M51.0107 24.5347C50.6157 24.1138 49.9543 24.0929 49.5334 24.4879C49.1126 24.8829 49.0917 25.5443 49.4867 25.9652L48.5723 26.8234C47.7032 25.8976 47.7493 24.4426 48.6752 23.5735C49.601 22.7045 51.0561 22.7506 51.9251 23.6764L51.0107 24.5347Z'
      fill='white'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M51.0107 24.5347C50.6157 24.1138 49.9543 24.0929 49.5334 24.4879C49.1126 24.8829 49.0917 25.5443 49.4867 25.9652L48.5723 26.8234C47.7032 25.8976 47.7493 24.4426 48.6752 23.5735C49.601 22.7045 51.0561 22.7506 51.9251 23.6764L51.0107 24.5347Z'
      fill='currentColor'
      fillOpacity='0.5'
    />
    <circle cx='50.5' cy='34.5' r='1.5' fill='white' />
    <circle cx='50.5' cy='34.5' r='1.5' fill='currentColor' fillOpacity='0.5' />
    <circle cx='19' cy='47' r='1' fill='white' />
    <circle cx='19' cy='47' r='1' fill='currentColor' fillOpacity='0.5' />
    <circle cx='39' cy='9' r='1' fill='white' />
    <circle cx='39' cy='9' r='1' fill='currentColor' fillOpacity='0.5' />
    <circle cx='6' cy='30' r='1' fill='white' />
    <circle cx='6' cy='30' r='1' fill='currentColor' fillOpacity='0.5' />
    <circle cx='16.5' cy='10.5' r='1.5' fill='white' />
    <circle cx='16.5' cy='10.5' r='1.5' fill='currentColor' fillOpacity='0.5' />
    <rect x='39' y='45.4062' width='5' height='1.47598' transform='rotate(-28.7559 39 45.4062)' fill='white' />
    <rect
      x='39'
      y='45.4062'
      width='5'
      height='1.47598'
      transform='rotate(-28.7559 39 45.4062)'
      fill='currentColor'
      fillOpacity='0.5'
    />
    <rect x='24.6953' y='3' width='5' height='2' transform='rotate(20.3421 24.6953 3)' fill='white' />
    <rect
      x='24.6953'
      y='3'
      width='5'
      height='2'
      transform='rotate(20.3421 24.6953 3)'
      fill='currentColor'
      fillOpacity='0.5'
    />
    <path
      d='M29 12C37.8366 12 45 19.1634 45 28C45 36.8366 37.8366 44 29 44H26C17.1634 44 10 36.8366 10 28C10 19.1634 17.1634 12 26 12H29Z'
      fill='currentColor'
    />
    <path d='M26 15C33.1797 15 39 20.8203 39 28C39 35.1797 33.1797 41 26 41V15Z' fill='white' />
    <path
      d='M26 15C33.1797 15 39 20.8203 39 28C39 35.1797 33.1797 41 26 41V15Z'
      fill='currentColor'
      fillOpacity='0.5'
    />
    <path d='M26 15C18.8203 15 13 20.8203 13 28C13 35.1797 18.8203 41 26 41V15Z' fill='white' />
    <path
      d='M26 15C18.8203 15 13 20.8203 13 28C13 35.1797 18.8203 41 26 41V15Z'
      fill='currentColor'
      fillOpacity='0.2'
    />
    <path
      d='M25.5245 21.4635C25.6741 21.0029 26.3259 21.0029 26.4755 21.4635L27.6839 25.1824C27.7508 25.3884 27.9428 25.5279 28.1594 25.5279H32.0696C32.554 25.5279 32.7554 26.1477 32.3635 26.4324L29.2001 28.7307C29.0248 28.8581 28.9515 29.0838 29.0184 29.2898L30.2268 33.0086C30.3764 33.4693 29.8492 33.8523 29.4573 33.5676L26.2939 31.2693C26.1186 31.1419 25.8814 31.1419 25.7061 31.2693L22.5427 33.5676C22.1508 33.8523 21.6236 33.4693 21.7732 33.0086L22.9816 29.2898C23.0485 29.0838 22.9752 28.8581 22.7999 28.7307L19.6365 26.4324C19.2446 26.1477 19.446 25.5279 19.9304 25.5279H23.8406C24.0572 25.5279 24.2492 25.3884 24.3161 25.1824L25.5245 21.4635Z'
      fill='currentColor'
    />
  </svg>
);
